module.exports = {
  environment: "development",
  apiUrl: "https://api.jibber.social",
};



// WEBPACK FOOTER //
// src/ENV.js